export default "__VITE_ASSET__lETkvy6v__"